import React from 'react';

import { t } from 'state/intl/translations';

import { CancellationPolicyText, Title, Wrapper } from './cancellation-policy.styled';

export const DeliveryCancellationPolicy = () => {
  return (
    <Wrapper>
      <Title>{t('cancellationPolicyTitle')}</Title>
      <CancellationPolicyText>{t('cancellationPolicy')}</CancellationPolicyText>
    </Wrapper>
  );
};
